function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTeamsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-teams-normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7,5.4A1.8,1.8,0,1,0,.9,3.6,1.8,1.8,0,0,0,2.7,5.4Zm12.6,0a1.8,1.8,0,1,0-1.8-1.8A1.8,1.8,0,0,0,15.3,5.4Zm.9.9H14.4a1.79,1.79,0,0,0-1.27.52A4.11,4.11,0,0,1,15.24,9.9H17.1A.9.9,0,0,0,18,9V8.1A1.8,1.8,0,0,0,16.2,6.3ZM9,6.3A3.15,3.15,0,1,0,5.85,3.15,3.15,3.15,0,0,0,9,6.3Zm2.16.9h-.23a4.35,4.35,0,0,1-3.85,0H6.84A3.24,3.24,0,0,0,3.6,10.44v.81A1.35,1.35,0,0,0,5,12.6h8.1a1.35,1.35,0,0,0,1.35-1.35v-.81A3.24,3.24,0,0,0,11.16,7.2ZM4.87,6.82A1.79,1.79,0,0,0,3.6,6.3H1.8A1.8,1.8,0,0,0,0,8.1V9a.9.9,0,0,0,.9.9H2.75A4.12,4.12,0,0,1,4.87,6.82Z",
    style: {
      fill: "#999"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamsNormal);
export default __webpack_public_path__ + "static/media/icon-teams-normal.927ba1c3e1b240e5700ff1392ece65a2.svg";
export { ForwardRef as ReactComponent };